/**
 * Shared helpers for Accounting Hub integration list payloads (REST `integrations/list`).
 */

export type IntegrationListItem = {
  id: string;
  name: string;
  logoUrl: string;
  authType: string;
  restBasePath: string;
  connected: boolean;
  disabled?: boolean;
};

export function sanitizeIntegrationListPayload(payload: unknown[]): IntegrationListItem[] {
  return payload.filter((item): item is IntegrationListItem => {
    if (typeof item !== 'object' || item === null) {
      return false;
    }
    const candidate = item as Partial<IntegrationListItem>;
    return (
      typeof candidate.id === 'string' &&
      typeof candidate.name === 'string' &&
      typeof candidate.logoUrl === 'string' &&
      typeof candidate.authType === 'string' &&
      typeof candidate.restBasePath === 'string' &&
      typeof candidate.connected === 'boolean'
    );
  });
}

/** Matches ImportWizardPage: only connected integrations that are not disabled. */
export function hasActiveConnectorForImport(connections: IntegrationListItem[]): boolean {
  return connections.some((c) => c.connected && !c.disabled);
}
